import React from "react";
import helperCSS from "../../../style/helperCSS/PersonalInfo.module.css";

const PersonalInfo = (props) => {
  return (
    <div className={`col-sm-6 col-xs-12 ${helperCSS.align}`}>
      <div>
        <b>
          <h6
            className={`${helperCSS.title} ${
              props.className ? props.className : "pink"
            }`}
          >
            {props.title}
          </h6>
        </b>
        {props.url ? (
          <a href={props.url} className={`${helperCSS.value}`}>
            {props.value}
          </a>
        ) : (
          <p className={`${helperCSS.value}`}>{props.value}</p>
        )}
      </div>
    </div>
  );
};

export default PersonalInfo;
